import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c54136e2&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=c54136e2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54136e2",
  null
  
)

export default component.exports